<template>
  <b-card class="shadow atm-rounded">
    <section class="p-4 d-flex flex-column justify-content-center align-items-center gap-4">
      <section class="d-flex flex-column w-100">
        <h5 class="font-weight-bold">Last week</h5>
        <h6 class="font-weight-bold">% of criteria met</h6>
      </section>
      <section>
        <b-row class="justify-content-center">
          <b-col cols="auto" class="my-4 text-center" v-for="(chart, index) in lastWeekCharts">
            <h6 class="font-weight-bold">{{ chart.moduleName }}</h6>
            <apexchart :options="chart.chartOptions" :series="chart.chartSeries" :key="index">
            </apexchart>
          </b-col>
        </b-row>
      </section>
    </section>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { criteriaMetLabelNames, donutChartResponsive } from '@/dashboard/constants';

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    criteriasMet: Object,
  },
  data() {
    return {
      lastWeekCharts: [],
      chartOptions: {
        labels: criteriaMetLabelNames,
        chart: {
          type: 'donut',
          zoom: {
            enabled: false,
          },
        },
        legend: {
          show: true,
          onItemClick: {
            toggleDataSeries: false,
          },
          onItemHover: {
            highlightDataSeries: false,
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
          },
          dropShadow: {
            enabled: false,
          },
        },
        responsive: donutChartResponsive,
      },
    };
  },
  methods: {
    generateCharts(data) {
      return data.map((criteria) => ({
        chartOptions: this.chartOptions,
        chartSeries: [
          criteria.allAproveChecklists,
          criteria.all_checklists,
          criteria.averageAproved,
        ],
        moduleName: criteria.moduleName,
      }));
    },
    processChartData() {
      this.lastWeekCharts = this.generateCharts(this.criteriasMet.lastWeek);
    },
  },
  watch: {
    criteriasMet: {
      handler(newVal) {
        if (newVal) this.processChartData();
      },
      immediate: true,
    },
  },
};
</script>
